"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));
var _react = _interopRequireWildcard(require("react"));
var _get = _interopRequireDefault(require("lodash/get"));
var _clsx = _interopRequireDefault(require("clsx"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styles = require("@material-ui/core/styles");
var _Skeleton = _interopRequireDefault(require("@material-ui/lab/Skeleton"));
const _excluded = ["src", "defaultSrc", "classes", "onError", "alt", "className", "loadingComponent", "backgroundColor", "aspectRatio", "height", "variant"];
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function (e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != typeof e && "function" != typeof e) return {
    default: e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) {
    var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
    i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
  }
  return n.default = e, t && t.set(e, n), n;
}
function ext(url) {
  return (url = url.substr(1 + url.lastIndexOf('/')).split('?')[0]).split('#')[0].substr(url.lastIndexOf('.'));
}
const getImageExtension = originalSrc => originalSrc ? ext(originalSrc) : '';
const useClasses = (0, _styles.makeStyles)(() => ({
  skeletonContainer: ({
    containerHeight,
    width,
    height = '100%'
  }) => ({
    width,
    height,
    minHeight: `${containerHeight}px`
  }),
  loadingComponent: ({
    containerHeight,
    backgroundColor,
    width = '100%',
    height = '100%'
  }) => ({
    width,
    height,
    backgroundColor,
    display: 'block',
    minHeight: `${containerHeight}px`
  }),
  loading: {
    display: 'none'
  },
  loaded: {
    display: 'block'
  }
}), {
  classNamePrefix: 'TCUIImage'
});
const TCImage = _ref => {
  let {
      src,
      defaultSrc,
      classes,
      onError,
      alt,
      className,
      loadingComponent,
      backgroundColor,
      aspectRatio,
      height,
      variant
    } = _ref,
    rest = (0, _objectWithoutPropertiesLoose2.default)(_ref, _excluded);
  const [containerHeight, setContainerHeight] = (0, _react.useState)(height);
  const imgRef = (0, _react.useRef)(null);
  const containerRef = (0, _react.useRef)(null);
  const _classes = useClasses({
    containerHeight,
    backgroundColor,
    width: rest.width,
    height
  });
  const [hasError, setHasError] = (0, _react.useState)(false);
  const [isLoading, setIsLoading] = (0, _react.useState)(true);
  (0, _react.useEffect)(() => {
    if (src) {
      const image = new Image();
      image.onload = () => {
        setHasError(false);
        setIsLoading(false);
      };
      image.onerror = e => {
        onError(e);
        setHasError(true);
      };
      image.src = src;
    }
  }, [src]); // no func

  (0, _react.useEffect)(() => {
    if ((0, _get.default)(imgRef, 'current.complete')) {
      setIsLoading(false);
    }
  }, [imgRef]);
  (0, _react.useEffect)(() => {
    if (!height && containerRef.current) {
      const [ratio1, ratio2] = aspectRatio.split(':');
      const height = containerRef.current.offsetWidth / ratio1 * ratio2;
      setContainerHeight(height);
    }
  }, [height, containerRef]);
  if (!src) return null;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, isLoading && /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)({
      [_classes.skeletonContainer]: isLoading
    }),
    ref: containerRef
  }, loadingComponent ? loadingComponent : /*#__PURE__*/_react.default.createElement(_Skeleton.default, {
    variant: variant,
    className: _classes.loadingComponent,
    width: "100%"
  })), /*#__PURE__*/_react.default.createElement("picture", null, /*#__PURE__*/_react.default.createElement("source", {
    srcSet: hasError ? defaultSrc : src,
    type: `image/${getImageExtension(hasError ? defaultSrc : src)}`
  }), /*#__PURE__*/_react.default.createElement("img", (0, _extends2.default)({}, rest, {
    height: height,
    ref: imgRef,
    src: hasError ? defaultSrc : src,
    alt: alt,
    className: (0, _clsx.default)(classes.root, className, {
      [_classes.loading]: isLoading,
      [_classes.loaded]: !isLoading,
      [classes.error]: hasError,
      [classes.success]: !hasError
    }),
    onLoad: () => setIsLoading(false)
  }))));
};
TCImage.propTypes = {
  url: _propTypes.default.string,
  defaultSrc: _propTypes.default.string,
  classes: _propTypes.default.object,
  className: _propTypes.default.string,
  onError: _propTypes.default.func,
  loadingComponent: _propTypes.default.node,
  // ie loadingComponent={<Skeleton variant='circle' />}
  alt: _propTypes.default.string,
  src: _propTypes.default.string,
  aspectRatio: _propTypes.default.string,
  enableLoading: _propTypes.default.bool,
  height: _propTypes.default.number,
  backgroundColor: _propTypes.default.string,
  variant: _propTypes.default.oneOf(['text', 'rect', 'circle'])
};
TCImage.defaultProps = {
  url: null,
  defaultSrc: null,
  classes: {},
  className: null,
  onError: () => null,
  loadingComponent: null,
  alt: null,
  src: null,
  aspectRatio: '16:9',
  height: null,
  backgroundColor: null,
  variant: 'rect'
};
var _default = exports.default = TCImage;